<template>
    <div>
        <MySmisForm
            formTitle="Completare (pas 3/48)"
            labelName="Referitoare la proiect"
            inputType="textarea"
            textToCopy="Copiază în clipboard"
            readonly
        >
        </MySmisForm>
    </div>
</template>

<script>
import MySmisForm from '@/pages/Aplicatii/M3/M3Sketch/components/mysmis/MySmisForm'

export default {
    components: {
        MySmisForm,
    },
    data() {
        return {
        }
    },
    computed: {
        allData() {
            return this.$store.getters['m3Sketch/allData']
        }
    },
    mounted() {

    },
    methods: {
    }
}
</script>

<style scoped>

</style>
